import { styled } from '@mui/material/styles';
import { badgeClasses as muiBadgeClasses } from '@mui/material/Badge';
import { badgeClasses } from '../../Badge/badgeClasses';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Typography from '../../Typography/Typography';

/** TODO: Update those colors once they are included in the palette */
const navigationColor = '#7A6E95';
const navigationHoverColor = '#4A396E';

export const LabelContainer = styled('div')({
  display: 'flex',
  alignItems: 'center'
});

export const StartAdornmentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginRight: theme.spacing(0.5)
}));

export const EndAdornmentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginLeft: theme.spacing(0.5)
}));

export const ValueContainer = styled('div')({
  display: 'flex'
});

export const ItemLabelName = styled(Typography, {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ theme, disabled }) => ({
  color: disabled ? theme.palette.action.disabled : theme.palette.grey[700],
  marginRight: theme.spacing(1),
  maxWidth: 145,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const ItemLabelValue = styled(Typography, {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ theme, disabled }) => ({
  ...theme.typography.button,
  color: disabled ? theme.palette.action.disabled : theme.palette.text.primary,
  maxWidth: 200,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const ItemLabelCounter = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(1.75),
  marginRight: theme.spacing(1.25)
}));

export const HelpIcon = styled(HelpOutlineIcon)(({ theme }) => ({
  color: navigationColor,
  marginRight: theme.spacing(0.5),
  '&:hover': {
    color: navigationHoverColor
  }
}));

/**
 * App Icon renderers styled components
 */

export const AppIconContainer = styled('span', {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ theme, disabled }) => ({
  color: disabled ? theme.palette.action.disabled : theme.palette.text.primary,
  paddingRight: theme.spacing(0.5)
}));

export const BadgeContainer = styled('span', {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ theme, disabled }) => ({
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.75),
  [`& .${muiBadgeClasses.badge}.${badgeClasses.counter}`]: {
    color: disabled && theme.palette.action.disabled,
    background: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.background.default
  }
}));
